import { useCallback } from "react"
import { useButtonClickTracking } from "#/services/analytics/useButtonClickTracking"

interface OriginStepClickData {
  name: string
  href?: string
  [key: string]: unknown
}

export function useOriginStepTracking(step: string) {
  const { trackButtonClick } = useButtonClickTracking()

  const trackStepButtonClick = useCallback(
    (data: OriginStepClickData) => {
      trackButtonClick({ ...data, step })
    },
    [trackButtonClick, step]
  )

  return { trackButtonClick: trackStepButtonClick }
}
